<template>
  <div :class="`addMember ${!$store.state.isMobile ? 'pcMember' : ''}`">
    <div class="contentTitle">{{title || '个人信息'}}</div>
    <div class="itemCard">
      <div class="lineContent">
        <div class="name">姓 名</div>
        <el-input v-model="member.personName" placeholder="请输入姓名" :maxlength="16"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">身份证号</div>
        <el-input v-model="member.cardNum" placeholder="请输入身份证号码"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">联系电话</div>
        <el-input v-model="member.phone" placeholder="请输入联系电话" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
      </div>
    </div>
    <div class="back" @click="back" v-if="title">取消</div>
    <div class="buttonNormal" @click="submit">确认提交</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member: {}
    };
  },

  props: ['editData', 'addType', 'title'],

  methods: {
    submit() {
      if (!this.member.cardNum || !this.member.personName) {
        return this.$message.error('请将基础信息填写完整！')
      }
      if (!this.member.phone && this.title != '成员信息') {
        return this.$message.error('请将基础信息填写完整！')
      }
      this.$emit('submitAdd', this.member)
    },

    back() {
      this.$parent.showAddMember = false
    }
  },

  created() {
    if (this.addType == 'edit') {
      this.member = this.editData
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.addMember{
  position: fixed;
  top: 5.5rem;
  .back{
    position: absolute;
    left: 0.6rem;
    bottom: 0.15rem;
    font-size: 0.45rem;
  }
  &.pcMember{
    position: relative;
    top: unset;
    align-items: center;
    .contentTitle{
      margin: 0.2rem;
      font-size: 0.3rem;
    }
    .itemCard{
      margin: 0.2rem;
      padding: 0.3rem;
      border-radius: 0.1rem;
    }
    .lineContent{
      .name{
        font-size: 0.2rem;
        width: 2rem;
      }
    }
    .buttonNormal{
      margin: auto;
      margin-top: 0.5rem;
      width: 2rem;
      height: 0.5rem;
      font-size: 0.3rem;
      line-height: 0.5rem;
    }
  }
  .contentTitle{
    margin: 0.5rem;
    margin-top: 1rem;
  }
  .lineContent{
    .name{
      width: 2.5rem;
    }
  }
  .buttonNormal{
    margin-top: 2rem;
  }
}
</style>
<style type="text/css">
  .pcMember input{
    height: 0.6rem !important;
    font-size: 0.2rem !important;
    width: 100% !important;
  }
</style>